import React from "react";
import { ChartContainer } from "./styled";

const organizationData = {
  name: "(주)에스엠정보통신 대표",
  color: "#103349",
  children: [
    {
      name: "부사장",
      color: "#787878",
      children: [
        {
          name: "브라더컴퍼니 대표",
          color: "#103349",
          children: [
            {
              name: "체인사업부",
              color: "#C2C2C2",
              children: [
                { name: "충만치킨&충남지사\n마초부엌&섬섬옥수\nSM할인마트\n동소예" },
                // { name: "마초부엌&섬섬옥수" },
                // { name: "SM할인마트" },
                // { name: "동소예" },
              ],
            },
          ],
        },
        {
          name: "상무이사",
          color: "#787878",
          children: [
            {
              name: "POS 영업관리부",
              color: "#C2C2C2",
              children: [
                { name: "POS영업1팀\nPOS영업2팀\nPOS영업3팀" },
                // { name: "POS영업2팀" },
                // { name: "POS영업3팀" },
              ],
            },
            {
              name: "고객지원부",
              color: "#C2C2C2",
              children: [
                { name: "SM.COM\n고객지원팀" },
                //  { name: "고객지원팀" }
              ],
            },
            {
              name: "전략기획부",
              color: "#C2C2C2",
              children: [
                { name: "스마트컴(무인주차관리)\nCCTV설치 및 관리\n배달콜대행관리" },
                // { name: "CCTV설치 및 관리" },
                // { name: "배달콜대행관리" },
              ],
            },
          ],
        },
      ],
    },
  ],
};

const Chart = ({ toggleImageView }) => {
  const renderTree = (node) => {
    return (
      <li key={node.name}>
        <span
          // className={node.name.includes("대표") ? "emphasize" : ""}
          style={{
            background: node?.color ? node.color : "#fff",
            color: node?.color ? "#fff" : "#000",
          }}>
          {node.name && node.name.includes("\n")
            ? node.name.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))
            : node.name}
        </span>
        {node.children && <ul>{node.children.map((child) => renderTree(child))}</ul>}
      </li>
    );
  };

  return (
    <ChartContainer>
      <img
        src="/img/shopTheme/sm_chart.png"
        onClick={() => toggleImageView("/img/shopTheme/sm_chart.png")}
      />
      {/* <div className="content">
        <div className="tree">
          <ul>{renderTree(organizationData)}</ul>
        </div>
      </div> */}
    </ChartContainer>
  );
};

export default Chart;
